import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileText, Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function HasilSimulasi() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/simulasi");
        const list = data.items || [];
        setItems(list);
        if (list.length) setSelected(list[0]);
      } catch { toast.error("Gagal memuat hasil simulasi"); }
      setLoading(false);
    })();
  }, []);

  const fileUrl = (id) => `${API}/api/simulasi/${id}/file`;
  const gviewer = (id) => `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl(id))}&embedded=true`;

  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <header className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="simulasi-home-link">
          <img src="/talenta-logo.png" alt="Talenta" className="h-10 w-10 rounded-full object-contain shrink-0" />
          <span className="font-heading font-black text-2xl"><span className="text-[#E25E3E]">Talenta</span><span className="text-[#F4B942]">Path</span></span>
        </Link>
        <Link to="/masuk" data-testid="simulasi-masuk-btn" className="px-5 py-2 rounded-full bg-[#1A1C1A] text-white text-sm font-medium hover:opacity-90 transition-opacity">Masuk</Link>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-8" data-testid="hasil-simulasi-page">
        <h1 className="font-heading font-black text-3xl sm:text-4xl text-[#1A1C1A] mb-2">Hasil Simulasi</h1>
        <p className="text-[#5C5F5C] mb-6">Kumpulan hasil simulasi TryOut TalentaPath. Pilih dari daftar untuk membaca PDF langsung di halaman ini.</p>

        {loading && <div className="text-sm text-[#9C9A94]">Memuat…</div>}
        {!loading && items.length === 0 && (
          <div className="clay-card p-8 text-center text-sm text-[#9C9A94]" data-testid="simulasi-empty">Belum ada hasil simulasi yang dipublikasikan.</div>
        )}

        {!loading && items.length > 0 && (
          <div className="grid lg:grid-cols-[300px_1fr] gap-4">
            {/* Daftar */}
            <aside className="clay-card p-2 h-fit lg:sticky lg:top-4" data-testid="simulasi-list">
              <div className="max-h-[70vh] overflow-auto space-y-1">
                {items.map((it) => {
                  const active = selected?.id === it.id;
                  return (
                    <button key={it.id} onClick={() => setSelected(it)} data-testid={`simulasi-item-${it.id}`}
                      className={`w-full text-left rounded-xl px-3 py-2.5 flex items-start gap-2.5 transition-colors ${active ? "bg-[#E25E3E]/10" : "hover:bg-[#F0ECE4]"}`}>
                      <FileText className={`h-4 w-4 mt-0.5 shrink-0 ${active ? "text-[#E25E3E]" : "text-[#9C9A94]"}`} />
                      <span className="min-w-0">
                        <span className={`block text-sm font-medium truncate ${active ? "text-[#E25E3E]" : "text-[#1A1C1A]"}`}>{it.title}</span>
                        {it.date_label && <span className="block text-xs text-[#9C9A94] truncate">{it.date_label}</span>}
                      </span>
                    </button>
                  );
                })}
              </div>
            </aside>

            {/* Viewer */}
            <div data-testid="simulasi-viewer">
              {selected && (
                <>
                  <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
                    <div className="min-w-0">
                      <div className="font-heading font-bold text-[#1A1C1A] truncate">{selected.title}</div>
                      {selected.date_label && <div className="text-xs text-[#9C9A94]">{selected.date_label}</div>}
                    </div>
                    <a href={fileUrl(selected.id)} target="_blank" rel="noreferrer" data-testid="download-simulasi-btn" className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full bg-[#3E6B8A] text-white shrink-0"><Download className="h-3.5 w-3.5" /> Unduh / Layar Penuh</a>
                  </div>
                  <div className="clay-card p-1 rounded-2xl overflow-hidden bg-white">
                    <iframe
                      key={selected.id}
                      title={selected.title}
                      data-testid="simulasi-iframe"
                      src={gviewer(selected.id)}
                      className="w-full rounded-xl bg-white"
                      style={{ height: "80vh", border: "none" }}
                    />
                  </div>
                  <p className="text-xs text-[#9C9A94] mt-2">Jika tampilan lambat memuat, tunggu beberapa detik atau klik "Unduh / Layar Penuh".</p>
                </>
              )}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
